export const JOB_TITLE = "Senior Full Stack Software Engineer";
export const EMPLOYER = "Karakun AG";

/**
 * Topics for machine-readable surfaces (JSON-LD knowsAbout, the profile API,
 * and the homepage Markdown topic list). Human-facing prose derives its topic
 * wording from DATA.bio instead.
 */
export const KNOWS_ABOUT = [
  "Java",
  "TypeScript",
  "software testing",
  "web performance",
  "application security",
  "open source",
  "conference speaking",
] as const;

export const ACE_AWARD = {
  name: "Oracle ACE Associate Award",
  url: "https://ace.oracle.com/apex/ace/profile/fm",
} as const;

export const SESSIONIZE_AWARDS = [{ year: 2024 }, { year: 2025 }].map(
  (award) => ({
    name: `Sessionize Most Active Speaker ${award.year} Award`,
    url: `https://sessionize.com/most-active-speakers-${award.year}/`,
    imageSrc: `/Most_Active_Speaker${award.year}.svg`,
    year: award.year,
  }),
);

export const AWARDS = [
  ACE_AWARD,
  ...SESSIONIZE_AWARDS.map(({ name, url }) => ({ name, url })),
] as const;

export const PROFILE_LINKS = [
  {
    href: "https://linkedin.com/in/fran%C3%A7oismartin",
    label: "LinkedIn",
    icon: "linkedin",
    className: "text-[#0A66C2] hover:bg-[#0A66C2]/20",
  },
  {
    href: "https://www.youtube.com/@fmartindev",
    label: "YouTube",
    icon: "youtube",
    className: "text-[#FF0000] hover:bg-[#FF0000]/20",
  },
  {
    href: "https://github.com/martinfrancois",
    label: "GitHub",
    icon: "github",
    className:
      "text-[#181717] dark:text-white hover:bg-[#181717]/20 dark:hover:bg-white/20",
  },
  {
    href: "https://bsky.app/profile/fmartin.ch",
    label: "Bluesky",
    icon: "bluesky",
    className: "text-[#0285FF] hover:bg-[#0285FF]/20",
  },
  {
    href: "https://fosstodon.org/@martinfrancois",
    label: "Mastodon",
    icon: "mastodon",
    className: "text-[#6364FF] hover:bg-[#6364FF]/20",
  },
  {
    href: "https://x.com/fmartin_",
    label: "X (formerly Twitter)",
    icon: "x-twitter",
    className:
      "text-black dark:text-white hover:bg-black/20 dark:hover:bg-white/20",
  },
] as const;

export const PROFILE_CONTACT_PATH = "/contact";
export const PROFILE_EMAIL_REDIRECT_PATH = "/contact/email";
// Linked from the Markdown twin of /contact instead of the HTML button, so
// agent-initiated mail arrives on its own alias.
export const PROFILE_AGENT_EMAIL_REDIRECT_PATH = `${PROFILE_EMAIL_REDIRECT_PATH}/agent`;
